export const enrichParticipantNames = async ({ matchData, matchId, apiBaseUrl }) => {
  if (
    !matchData?.participant_1_id ||
    !matchData?.participant_2_id ||
    (matchData.participant1Name && matchData.participant2Name)
  ) {
    return matchData;
  }

  try {
    const participantResponse = await fetch(
      `${apiBaseUrl}/matches/${matchId}/participants`,
      { credentials: "include" }
    );

    if (!participantResponse.ok) {
      return matchData;
    }

    const participantData = await participantResponse.json();

    return {
      ...matchData,
      participant1Name: participantData.participant1Name,
      participant2Name: participantData.participant2Name,
      participant1FirstName: participantData.participant1FirstName,
      participant1LastName: participantData.participant1LastName,
      participant2FirstName: participantData.participant2FirstName,
      participant2LastName: participantData.participant2LastName,
    };
  } catch (err) {
    console.warn("Could not fetch participant names:", err);
    return matchData;
  }
};
